(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusReviewControllers', [
            'recomModule'
        ]);
})();
